module.exports = __webpack_public_path__ + "img/banner-3.f289b940.png";